import React from "react";
import { formatNumber } from "../../../../../Utils/utils";
import FormTitle from "../../../../../Components/FormElements/FormTitle";

interface FirstCardImproveModalityProps {
  data: any;
  selectedModality: any;
  typeMoneyDescriptionList: any;
  isInitialModality?: boolean;
}

const FirstCardImproveModality = ({
  data,
  selectedModality,
  typeMoneyDescriptionList,
  isInitialModality = false,
}: FirstCardImproveModalityProps) => {

  const respuestaMacro = isInitialModality === false 
    ? selectedModality && selectedModality.respuestaMacro
      ? selectedModality.respuestaMacro
      : null
    : selectedModality && selectedModality.respuestaMacroInicial
      ? selectedModality.respuestaMacroInicial
      : null;

  const periodoDiferido = parseInt(
    respuestaMacro && respuestaMacro.periodoDiferido
      ? respuestaMacro.periodoDiferido
      : "0",
    10
  );
  const tasaVentaActual = respuestaMacro
    ? periodoDiferido > 0
      ? respuestaMacro.tasaInteresRt
      : respuestaMacro.tasaInteresRv
    : null;

  return (
    <>
      {isInitialModality === true ? (<FormTitle title="Valor Inicial" />) : (<FormTitle title="Mejorar Modalidad" />)}
      <div className="card-verify ">
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Nro. Cotización</div>
          <div className="card-verify__data">{data.nroOperacion}</div>
        </div>
        <div>
          <div className="card-verify__quote">Modalidad</div>
          <div className="card-verify__data">{selectedModality.modalidad}</div>
        </div>
        <div>
          <div className="card-verify__quote">Diferimiento</div>
          <div className="card-verify__data">{selectedModality.anosRT}</div>
        </div>
      </div>
      <div className="card-verify__rows-line"></div>
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Garantizado</div>
          <div className="card-verify__data">
            {selectedModality.periodoGarantizado}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Capital Pensión</div>
          <div className="card-verify__data">
            {respuestaMacro && respuestaMacro.primaCia
              ? formatNumber.new(respuestaMacro.primaCia)
              : "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Moneda</div>
          <div className="card-verify__data">
            {typeMoneyDescriptionList[selectedModality.moneda]}
          </div>
        </div>
      </div>
      <div className="card-verify__rows-line"></div>
      <div className="card-verify__rows">
        {selectedModality.reajuste && (
          <div>
            <div className="card-verify__quote">Reajuste</div>
            <div className="card-verify__data">{selectedModality.reajuste}</div>
          </div>
        )}
        {respuestaMacro && (
          <div>
            <div className="card-verify__quote">Prima Única AFP</div>
            <div className="card-verify__data">
              {formatNumber.new(respuestaMacro.primaAfp) || "--"}
            </div>
          </div>
        )}
        {respuestaMacro && (
          <div>
            <div className="card-verify__quote">Tasa de Venta Actual</div>
            <div className="card-verify__data">
              {respuestaMacro.tasaInteresRv ? `${respuestaMacro.tasaInteresRv}%` : "--"}
            </div>
          </div>
        )}
      </div>
      </div>
    </>
  );
};

export default FirstCardImproveModality;
